import IndexPage from '../components/PORT/IndexPage'
export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.jsx